export default "__VITE_ASSET__1b9ab3bb__"